import React from "react";
import { observer } from "mobx-react-lite";
import { Button, Chip } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useStore } from "../../helpers";

const getFilterLabel = (key: string, value: any) => {
    switch (key) {
        case "villages":
            return (
                value?.name ||
                value?.label ||
                value?.village ||
                value?.location ||
                "Village"
            );

        case "status":
            return value?.status || value?.name || value;

        case "start_date":
            return `From: ${value}`;

        case "end_date":
            return `To: ${value}`;

        default:
            return value;
    }
};

const removeEmptyValues = (filters: any) => {
    const result: any[] = [];

    Object.entries(filters || {}).forEach(([key, value]: any) => {
        if (Array.isArray(value) && value.length > 0) {
            result.push({ key, value });
        }

        if ((key === "start_date" || key === "end_date") && value) {
            result.push({ key, value });
        }
    });

    return result;
};

export const ProjectWorksFilteredBy = observer(() => {
    const { projectWorksStore } = useStore();
    const { filters } = projectWorksStore;

    const activeFilters = removeEmptyValues(filters);

    if (activeFilters.length === 0) return null;

    const handleClearSingle = (key: string, valueToRemove?: any) => {
        const updatedFilters = { ...filters };

        if (Array.isArray(updatedFilters[key])) {
            updatedFilters[key] = updatedFilters[key].filter(
                (v: any) => v !== valueToRemove
            );
        } else {
            updatedFilters[key] = "";
        }

        projectWorksStore.updateFilters(updatedFilters);
    };

    const handleClearAll = () => {
        projectWorksStore.resetFilters();
    };

    return (
        <div className="bg-white rounded-xl shadow-sm p-4 mb-4 border border-gray-200">
            <div className="flex flex-wrap items-center gap-2">
                <span className="text-sm font-medium text-gray-700 mr-2">
                    Filtered By :
                </span>

                <div className="flex flex-wrap gap-2 flex-1">
                    {activeFilters.map(({ key, value }) =>
                        Array.isArray(value) ? (
                            value.map((item: any, idx: number) => (
                                <Chip
                                    key={`${key}-${idx}`}
                                    label={getFilterLabel(key, item)}
                                    onDelete={() =>
                                        handleClearSingle(key, item)
                                    }
                                    size="small"
                                    sx={{
                                        backgroundColor: "#EFF6FF",
                                        color: "#1E40AF",
                                        fontWeight: 500,
                                        "& .MuiChip-deleteIcon": {
                                            color: "#3B82F6",
                                            "&:hover": { color: "#1E40AF" },
                                        },
                                    }}
                                />
                            ))
                        ) : (
                            <Chip
                                key={key}
                                label={getFilterLabel(key, value)}
                                onDelete={() => handleClearSingle(key)}
                                size="small"
                                sx={{
                                    backgroundColor: "#EFF6FF",
                                    color: "#1E40AF",
                                    fontWeight: 500,
                                    "& .MuiChip-deleteIcon": {
                                        color: "#3B82F6",
                                        "&:hover": { color: "#1E40AF" },
                                    },
                                }}
                            />
                        )
                    )}
                </div>

                <Button
                    variant="text"
                    color="error"
                    size="small"
                    startIcon={<CloseOutlinedIcon fontSize="small" />}
                    onClick={handleClearAll}
                    sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        minWidth: "auto",
                    }}
                >
                    Clear Filters
                </Button>
            </div>
        </div>
    );
});
